<template>
  <div class="contentContainer">
    <div class="PrintTools">
      <div class="ToolbarRight">
        <el-button @click="printOrderDetail()">印刷</el-button>
        <el-button @click="goBackOrderDetail()">戻る</el-button>
      </div>
    </div>
    <div
      v-for="(order, index) in ordersForPrint"
      :key="`print-order-${order.id || index}`"
      class="OrderPreview print-order-preview"
    >
      <p class="previewTitle">お位牌文字原稿</p>
      <div class="table">
        <div class="container">
          <div style="text-align: right">
            <span style="font-size: 10pt;"
              ><strong>{{ order.orderNumber }}</strong></span
            >
          </div>

          <div class="rowGroup">
            <div class="row">
              <div class="col th">御芳名</div>
              <div class="col td">
                <span v-if="order.customer">{{ order.customer.name }} 様</span>
              </div>
            </div>
            <div class="row">
              <div class="col th">住所</div>
              <div class="col td">
                <span v-if="order.customer.address"
                  >{{ order.customer.zipcode }} {{ order.customer.address }}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col th bottom">TEL</div>
              <div class="col td bottom">
                <span v-if="order.customer.tel">{{ order.customer.tel }}</span>
              </div>
            </div>
          </div>

          <div class="rowGroup">
            <div class="row">
              <div class="col th">商品名</div>
              <div class="col td productNameCell">
                <span
                  v-if="
                    (displayProductName !== null && displayProductName !== '') &&
                      order.detail.product.name !== '保志以外へのご注文'
                  "
                  >{{ displayProductName }}</span
                >
              </div>
              <div class="col th">寸法</div>
              <div class="col td">
                <span
                  v-if="
                    (displaySize !== null && displaySize !== '') &&
                      order.detail.product.name !== '保志以外へのご注文'
                  "
                  >{{ displaySize }}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col th bottom">彫・書の種類</div>
              <div class="col td bottom">
                {{
                  order.detail.typography.printType === "CARVE"
                    ? "戒名彫"
                    : "戒名書"
                }}
              </div>
              <div class="col td bottom">
                {{
                  fontName == "合掌体"
                    ? "機械書"
                    : fontName == "機械書手彫風書体"
                      ? "機械書(手彫風書体)"
                      : fontName
                }}
              </div>
            </div>
          </div>

          <div class="rowGroup">
            <div class="row">
              <div class="col th">四十九日法要日</div>
              <div class="col td">
                {{ getFormatDate(order.detail.fortyNinthMemorialServiceDate) }}
              </div>
            </div>
            <div class="row">
              <div class="col th">ご契約日</div>
              <div class="col td">
                {{ getFormatDate(order.detail.contractDate) }}
              </div>
            </div>
            <div class="row">
              <div class="col th">納品日</div>
              <div class="col td">
                {{ getFormatDate(order.detail.deliveryDate) }}
              </div>
            </div>
            <div class="row">
              <div class="col th bottom">備考</div>
              <div class="col td bottom pre-wrap">
                <span
                  v-if="order.customer && order.customer.note"
                  v-html="$sanitize(order.customer.note.replace(/\n/g, '<br/>'))"
                />
              </div>
            </div>
          </div>

          <div class="rowGroup">
            <div class="row">
              <div class="col th">店舗</div>
              <div class="col td">
                <span v-if="order.clientGroup && order.clientGroup.name">{{
                  order.clientGroup.name
                }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col th bottom">支店</div>
              <div class="col td bottom">
                <span
                  v-if="
                    order.deliveryDestination && order.deliveryDestination.name
                  "
                  >{{ order.deliveryDestination.name }}</span
                >
              </div>
            </div>
          </div>

          <!-- 自由項目 -->
          <div
            v-if="order.customFieldInformation && order.customFieldInformation.length"
            class="rowGroup"
          >
            <div
              v-for="(item, index) in order.customFieldInformation"
              class="row"
              :key="`customField-${item[0]}-${index}`"
            >
              <div
                class="col th"
                :class="{
                  bottom: isEndRow(index),
                }"
              >{{ item[0] }}</div>
              <div
                class="col td"
                :class="{
                  bottom: isEndRow(index),
                }"
              >{{ item[1] }}</div>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex">
        <TabletPreview
          v-if="order.fontColors"
          :order="order"
          :frontColor="order.fontColors[1]"
          :backColor="order.fontColors[0]"
          :is-show-description="true"
          :is-adjust-description="true"
        />
          <div
            v-if="order.detail && order.detail.product"
            class="TablePreview productInfo"
            style="display: block"
          >
          <div
            v-if="
              order.detail.product.name &&
              order.detail.product.name !== '保志以外へのご注文'
            "
          >
            <img :src="order.detail.product.imageUrl[0]" class="Tablet" />
            <div class="productInfo">
              <p class="productDetail productNumber">
                {{ order.detail.product.number }}
              </p>
              <p class="productDetail product-inline">
                {{ displayProductName }}
              </p>
              <p class="productDetail product-inline">
                {{ displaySize }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="table">
        <div class="container">
          <div class="row">
            <div class="col td bottom" style="border-right: none;">
              <span style="font-size: 16pt;">
                <strong>
                  <span v-if="order.client.clientGroup">
                    {{ order.client.clientGroup.storeName }}
                  </span>
                </strong>
              </span>
              <br />
              <span style="font-size: 9pt;" v-if="order.client.clientGroup">
                TEL：{{ order.client.clientGroup.contactTel }} FAX：{{
                  order.client.clientGroup.contactFax
                }}
              </span>
            </div>
            <div
              class="col td bottom"
              style="text-align: right; vertical-align: bottom; border-left: none;"
            >
              <span v-if="order.client">
                担当：
                <strong>
                  {{ order.client.name }}
                </strong>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import OrderUsecase from "@/usecases/order.usecase";
import Order from "@/entities/order.entity";
// import InformationTable from "@/components/InformationTable";
import TabletPreview from "@/components/Common/TabletPreview.vue";
import moment from "moment";
export default {
  components: {
    // InformationTable,
    TabletPreview,
  },
  data () {
    return {
      orderUsecase: new OrderUsecase(),
      order: {},
    };
  },
  async created () {
    this.syncOrder();
  },
  computed: {
    ...mapState({
      orderId: state => state.orderForm.setOrderId,
    }),
    fontName: function () {
      const font =
        this.order &&
        this.order.detail &&
        this.order.detail.typography &&
        this.order.detail.typography.font;
      return font === "標準書体" ? "楷書体" : (font || "");
    },
    ordersForPrint () {
      if (!this.order || !this.order.id) {
        return [];
      }
      const childOrders = Array.isArray(this.order.childOrders)
        ? this.order.childOrders
        : [];
      const baseOrder = this.order;
      return [baseOrder, ...childOrders]
        .filter(order => order && order.detail)
        .map(order => {
          const entity =
            order instanceof Order ? order : Order.fromJson(order);
          const detail = entity.detail || {};
          return {
            ...entity,
            // スプレッドでは Order のゲッターが落ちるため明示する
            fontColors: entity.fontColors,
            customFieldInformation: entity.customFieldInformation,
            customer: entity.customer || {},
            clientGroup: entity.clientGroup || baseOrder.clientGroup || {},
            deliveryDestination:
              entity.deliveryDestination ||
              baseOrder.deliveryDestination ||
              {},
            client: entity.client || baseOrder.client || {},
            detail: {
              ...detail,
              product: detail.product || {},
              productVariation: detail.productVariation || {},
              typography: detail.typography || {},
            },
          };
        });
    },
    isAzukariIhaiProduct () {
      const { detail } = this.order;
      return (
        detail &&
        detail.product &&
        detail.product.category &&
        detail.product.category.id === "99000"
      );
    },
    displayProductName () {
      const { detail } = this.order;
      if (!detail || !detail.product) return null;
      if (this.isAzukariIhaiProduct && detail.azukariProductName) {
        return `お預かり ${detail.azukariProductName}`;
      }
      return detail.product.name || null;
    },
    displaySize () {
      const { detail } = this.order;
      if (!detail || !detail.productVariation) return null;
      if (this.isAzukariIhaiProduct && detail.azukariProductSize != null && detail.azukariProductSize !== "") {
        return detail.azukariProductSize;
      }
      return detail.productVariation.size || null;
    },
  },
  methods: {
    async syncOrder () {
      // get order ID
      const orderId = this.orderId;
      // get order
      const currentOrder = await this.orderUsecase.getOrder({ orderId });
      let order = currentOrder;

      // 子注文詳細から遷移した場合でも、印刷は親+子のセットで表示する
      if (
        currentOrder &&
        currentOrder.parentOrder &&
        currentOrder.parentOrder.id
      ) {
        const parentOrder = await this.orderUsecase.getOrder({
          orderId: currentOrder.parentOrder.id,
        });
        if (parentOrder) {
          order = parentOrder;
        }
      }

      this.order = order;

      if (!this.order) {
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: "<span style='color:#ee220c;'>データが存在しません。</span>",
        });
        document.querySelector(".el-notification").style.background = "#f6c0b9";
        this.$router.push("/home");
      } else {
        setTimeout(async () => {
          this.printOrderDetail();
        }, 500);
      }
    },
    goBackOrderDetail () {
      const { $router } = this;
      const id = this.orderId;
      $router.push(`/orders/${id}`);
    },
    printOrderDetail () {
      window.print();
    },
    getFormatDate (mDate) {
      if (!mDate) {
        return "";
      }
      return moment(mDate).format("YYYY年M月D日");
    },

    /**
     * [isEndRow description]
     * @param   {[type]}  index  [index description]
     * @return  {[type]}         [return description]
     */
    isEndRow (index) {
      const endRowIndex = this.order.customFieldInformation.length - 1;

      return index === endRowIndex;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

@media print {
  @page {
    margin-bottom: 1rem;
    margin-top: 1rem;
  }
  .contentContainer {
    overflow: hidden;
  }
  .ToolbarRight {
    display: none;
    height: 1px;
  }
  .Toolbar {
    display: none;
    height: 1px;
  }
  .Tablet {
    margin: 20pt 0 !important;
    vertical-align: bottom !important;
    width: 180pt !important;
    height: 260pt !important;
    object-fit: cover !important;
  }
  .OrderPreview {
    text-align: center !important;
    margin-left: auto !important;
    margin-right: auto !important;
    margin-top: 0 !important;
    width: 420pt !important;
  }
  .box {
    width: 30% !important;
  }
  .TabletPreview {
    align-self: center !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 260pt !important;
  }
  .TabletPreview .Body {
    text-align: center !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .TabletPreview .Header {
    margin-left: 0 !important;
  }
  .TabletPreview .Footer {
    margin-left: 0 !important;
  }
  .TabletPreview .FrontView {
    text-align: left !important;
    margin: 1rem !important;
  }
  .TabletPreview .BackView {
    text-align: left !important;
    margin: 1rem !important;
  }
  .TabletPreview .productInfo {
    text-align: left !important;
    margin: 0 !important;
  }
  .productInfo {
    text-align: center;
  }
  .productNumber {
    padding-right: 0 !important;
  }
  .previewTitle {
    font-size: 1rem !important;
    height: 1rem !important;
    margin: 0 !important;
  }
  .container {
    width: 420pt;
    text-align: left;
  }
  .table {
    width: 420pt;
    align-self: center;
    margin: 0.3rem 0 !important;
  }
  .table .row {
    display: table;
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
  }
  .table .row .col.th {
    font-size: 0.8rem;
    display: table-cell;
    padding: 0.2rem;
    border: 1px solid black;
    border-bottom: none;
    width: 20%;
    background-color: lightgray;
    text-align: center;
  }
  .table .row .col.td {
    font-size: 0.8rem;
    display: table-cell;
    padding: 0.2rem;
    border: 1px solid black;
    border-bottom: none;
    width: auto;
  }
  .table .row .col.td.productNameCell {
    min-width: 140pt;
  }
  .table .row .col.th.bottom {
    display: table-cell;
    padding: 0.3rem;
    border: 1px solid black;
    width: 20%;
    background-color: lightgray;
    text-align: center;
  }
  .table .row .col.td.bottom {
    display: table-cell;
    padding: 0.3rem;
    border: 1px solid black;
    width: auto;
  }
}

.PrintTools {
  display: flex;
  align-items: center;
  text-align: center;
  padding-top: 2rem;
}

.ToolbarRight {
  flex: 1;
  text-align: right;
  padding-right: 2rem;
}
.Tablet {
  margin: 20pt 0;
  vertical-align: bottom;
  width: 180pt !important;
  height: 260pt !important;
  object-fit: cover !important;
}
.OrderPreview {
  text-align: center !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding-left: 0 !important;
  width: 420pt !important;
}
.print-order-preview + .print-order-preview {
  page-break-before: always;
}
.box {
  width: 25%;
  float: right;
  padding-right: 1rem;
  box-sizing: border-box;
}
.order-info {
  font-size: 1.7rem;
  font-weight: bold;
  text-align: center;
  margin-top: 0.5rem;
}
.previewTitle {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 0.5rem;
  height: 20px;
}
.product-inline {
  display: inline-block;
}
.TabletPreview {
  align-self: center !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  width: 260pt !important;
}
.TabletPreview .Body {
  text-align: center !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.TabletPreview .Header {
  margin-left: 0 !important;
}
.TabletPreview .Footer {
  margin-left: 1rem !important;
}
.TabletPreview .FrontView {
  text-align: left !important;
  margin-right: 0.5rem !important;
  margin-left: 0 !important;
}
.TabletPreview .BackView {
  text-align: left !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.TabletPreview .productInfo {
  text-align: left !important;
  margin-right: 0.5rem !important;
  margin-left: 0 !important;
}
.productDetail {
  margin: 0 0.3rem 0;
  font-size: 14px;
  font-weight: bold;
}
.container {
  width: 420pt;
  text-align: left;
}
.table {
  width: 420pt;
  align-self: center;
  align-content: center;
  margin: 0.3rem 0;
}
.table .rowGroup {
  margin-bottom: 3px;
}
.table .row {
  display: table;
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
}
.table .row .col.th {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  border-bottom: none;
  width: 20%;
  background-color: lightgray;
  text-align: center;
}
.table .row .col.td {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  border-bottom: none;
  width: auto;
}
.table .row .col.th.bottom {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  width: 20%;
  background-color: lightgray;
  text-align: center;
}
.table .row .col.td.bottom {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  width: auto;
}
</style>
